export default __webpack_public_path__ + "static/media/qiwi_logo.8c17e936.svg";